// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"98433e79","115":"9809e9c8","142":"20da0dca","231":"2eb966ef","289":"3222d5ec","351":"b9b9fb66","392":"87c4e3a6","447":"9809e9c8","517":"c413a28e","730":"2ac84734","900":"9809e9c8","970":"20da0dca"}[chunkId] + ".chunk.css";
};